module.exports = __webpack_public_path__ + "static/img/pitch_green_HQ.909b85a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_green_HQ.png
// module id = nQsG
// module chunks = 79